import type { Dictionnaire } from '../type';

export const carte: Dictionnaire['carte'] = {
  ecran: {
    voirTout: 'See all',
    dansLaZone: 'In this area',
    impossible: "Can't do that right now.",
    recherchePosition: 'Finding your location…',
    activerLocalisation: 'Turn on location to see yourself on the map',
    unSansAdresse: "One event without a precise address isn't shown.",
    revenir: 'Back to my location',
    personneInscrit: 'No one signed up yet',
    inscrit: "You're signed up",
    demandeEnvoyee: 'Request sent',
    listeAttente: 'Join the waiting list',
    rejoindre: 'Join this event',
    plusTard: 'Maybe later',
    aucun: 'No events',
    un: '1 event',
    videCarte: 'No events are on the map yet. New ones will appear here on their own.',
    videZone: 'Nothing in this part of the map. Zoom out or move it to see others.',
    sansAdresse: (n: number) => `${n} events without a precise address aren't shown.`,
    participants: (n: number) => (n === 1 ? '1 participant' : `${n} participants`),
    memeEndroit: (n: number) => `${n} events in the same place`,
    plusieurs: (n: number) => `${n} events`,
  },
  apple: {
    pasOuverte: "The Apple map couldn't open.",
    pasChargee: "The Apple map couldn't load.",
  },
  libre: {
    pasAffichee: "The map couldn't be displayed on this device.",
    pasChargee: "The map couldn't load. Check your connection.",
  },
  placer: {
    titre: 'Place on campus',
    deplacer: 'Drag the marker to adjust it.',
    toucher: 'Tap the map where the event is.',
    placerIci: 'Place here',
  },
  pastilles: {
    maPosition: 'My location',
    sortie: (titre: string, categorie: string, spontanee: boolean) =>
    `${titre}, ${categorie.toLowerCase()}${spontanee ? ', spontaneous' : ''}`,
    groupe: (n: number) => `${n} outings at this spot`,
  },
  maquette: {
    pasAffichee: "The model couldn't be displayed on this device.",
  },
  placerMaquette: {
    pasAffichee: "The model can't be displayed on this device.",
    deplacer: 'Tap elsewhere to move it.',
    toucher: 'Tap the model where the event is.',
  },
  apercu: {
    credits: '© OpenStreetMap · OpenFreeMap',
    carteDuLieu: (lieu: string) => `Map of the venue: ${lieu}`,
  },
};
